import { AxiosResponse } from 'axios';
import { Workspace } from './types';

export const mapGetWorkspaceResponseToPayload = (res: AxiosResponse<Workspace[]>): Workspace[] =>
	res.data.sort((w1, w2) => w1.name.localeCompare(w2.name));
